
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';

interface ProductBasicInfoProps {
  name: string;
  setName: (name: string) => void;
}

const ProductBasicInfo = ({ name, setName }: ProductBasicInfoProps) => {
  return (
    <Card className="shadow-sm border border-gray-200 dark:border-gray-800">
      <CardContent className="pt-6">
        <div className="mb-4">
          <Label htmlFor="name" className="text-gray-700 dark:text-gray-300">Titre</Label>
          <Input 
            id="name" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            placeholder="Nom du produit"
            className="mt-1 bg-white dark:bg-gray-800/50 dark:text-gray-200 dark:border-gray-700"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductBasicInfo;
